import { jsx32bqjs36pyex9 as jsx } from '../../kotlin-react-core/react/jsx/runtime/jsx.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function create(_this__u8e3s4, block) {
  // Inline function 'js.objects.unsafeJso' call
  // Inline function 'js.objects.unsafeJso' call
  // Inline function 'kotlin.apply' call
  var this_0 = {};
  block(this_0);
  return jsx(_this__u8e3s4, this_0);
}
//region block: exports
export {
  create as createywkzgrq4l4xy,
};
//endregion

//# sourceMappingURL=create.mjs.map
